export default {
    storage(data) {
        return 'https://storage.googleapis.com/faa-files/' + data
    }
}